<template>
  <div>
    <b-button 
      class="ml-1 mt-0"
      size="sm" 
      v-for="btn in $options.buttons" 
      :pressed="isMetricButtonSelected(btn.id)" 
      :variant="btn.variant" 
      :key="btn.id"
      @click="changeMetric(btn)"
    >
        {{ btn.caption }}
    </b-button>
  </div>

</template>

<script>
  export default {
    buttons: [
      {
        id: 1,
        variant: 'outline-secondary',
        caption: 'U',
        value: 'UNITS'
      },
      {
        id: 2,
        variant: 'outline-secondary',
        caption: '$',
        value: 'PESOS'
      }
    ],
    data () {
      return {
        selectedMetricButtonId: null
      }
    },
    created () {
      const metricButton = this.$options.buttons.find(metric => metric.value ===  this.$store.state.metric)
      this.selectedMetricButtonId = metricButton.id
    },
    methods: {
      isMetricButtonSelected (id) {
        return this.selectedMetricButtonId === id
      },
      changeMetric (metricButton) {
        this.selectedMetricButtonId = metricButton.id
        // TODO: this state is not reactive, make it reactive and check the impact on it
        this.$store.commit('commit_mainMetric', metricButton.value)
        this.$emit('change-metric')
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/expertoRetail/atoms/MetricSwitchButtons/MetricSwitchButtons.vue